import {Signal} from 'typed-signals';

import {debounce} from '@lib/utils';

export class WindowService {
  static singleton: WindowService;
  public onResize = new Signal<() => void>();

  static create() {
    if (WindowService.singleton) {
      return WindowService.singleton;
    }
    return (WindowService.singleton = new WindowService());
  }

  constructor() {
    this.onChange = this.onChange.bind(this);
    window.addEventListener('resize', debounce(this.onChange, 100));
  }

  onChange() {
    this.onResize.emit();
  }

  // TODO: こんなんでいいのか・・・・
  get orientation() {
    return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
  }
}
